import { render } from "./ChargebeeQuotaDialog.vue?vue&type=template&id=4a152252&scoped=true"
import script from "./ChargebeeQuotaDialog.vue?vue&type=script&lang=js"
export * from "./ChargebeeQuotaDialog.vue?vue&type=script&lang=js"

import "./ChargebeeQuotaDialog.vue?vue&type=style&index=0&id=4a152252&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a152252"]])

export default __exports__